module.exports = __webpack_public_path__ + "img/C116.0e5368cf.jpg";